import { render, staticRenderFns } from "./FreeTextQuestionGroup.vue?vue&type=template&id=466b3c52&scoped=true&lang=pug"
import script from "./FreeTextQuestionGroup.vue?vue&type=script&lang=ts"
export * from "./FreeTextQuestionGroup.vue?vue&type=script&lang=ts"
import style0 from "./FreeTextQuestionGroup.vue?vue&type=style&index=0&id=466b3c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b3c52",
  null
  
)

export default component.exports